<!-- src/components/WipeDBModal.vue -->
<template>
  <div
    v-if="isOpen"
    class="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50"
  >
    <div
      class="bg-pitch-black p-6 rounded-lg shadow-lg text-center max-w-sm border border-light-grey-translucent-dark w-full mx-4"
    >
      <h2 class="text-xl text-total-white mb-4">Wipe Entire DB?</h2>
      <p class="text-sm text-left text-total-white mb-10">
        Are you sure you want to wipe the entire DB? This operation might be irreversible!
      </p>
      <div class="flex justify-around text-sm">
        <!-- "Reset" style button, but text "Wipe DB" -->
        <button @click="confirmWipe" class="bg-deep-rust text-white px-6 py-1 rounded-lg">
          Wipe DB
        </button>
        <button @click="cancelWipe" class="bg-gray-700 text-white px-6 py-1 rounded-lg">
          Cancel
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "WipeDBModal",
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    confirmWipe() {
      this.$emit("confirmWipe");
    },
    cancelWipe() {
      this.$emit("cancelWipe");
    },
  },
};
</script>

<style scoped>
/* If needed, style similarly to ResetProjectModal */
</style>
